import React, { useState } from 'react';
import { Form, Input, InputNumber, Button, message } from 'antd';
import { equipamentosService } from '../../services/api';

/**
 * Step 2: Usina Solar - cadastra equipamento tipo SOLAR vinculado ao site
 */
const StepUsinaSolar = ({ siteId, currentStep, totalSteps, onPrev, onNext }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [saved, setSaved] = useState(false);

    const handleSave = async () => {
        if (!siteId) {
            message.error('Selecione ou salve um site no passo anterior.');
            return;
        }
        try {
            setLoading(true);
            await form.validateFields();
            const values = form.getFieldsValue();
            const payload = {
                name: values.nome || 'Usina Solar',
                type: 'SOLAR',
                status: 'CONECTADO',
                siteId,
                capacity: values.capacidadeKw ? Number(values.capacidadeKw) : null,
                manufacturer: values.fabricante || null,
                model: values.modelo || null,
                serialNumber: values.numeroSerie || null,
                goodweDeviceId: values.goodwePlantId || null,
            };
            const res = await equipamentosService.create(payload);
            const equipment = res?.data ?? res;
            if (equipment?.id) {
                message.success('Usina Solar cadastrada com sucesso!');
                setSaved(true);
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Erro ao salvar Usina Solar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 24, backgroundColor: 'white' }}>
            <h2 style={{ color: '#2957A4', marginBottom: 16 }}>Usina Solar</h2>
            <Form form={form} layout="vertical">
                <Form.Item name="nome" label="Nome" rules={[{ required: true }]}>
                    <Input placeholder="Ex: Usina Solar Principal" />
                </Form.Item>
                <Form.Item name="capacidadeKw" label="Potência (kWp)" rules={[{ required: true }]}>
                    <InputNumber placeholder="Ex: 50" min={0} step={0.1} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name="fabricante" label="Fabricante">
                    <Input placeholder="Ex: Goodwe, Growatt" />
                </Form.Item>
                <Form.Item name="modelo" label="Modelo">
                    <Input placeholder="Ex: GW50K-MT" />
                </Form.Item>
                <Form.Item name="numeroSerie" label="Número de Série">
                    <Input placeholder="Ex: GW12345678" />
                </Form.Item>
                <Form.Item name="goodwePlantId" label="Goodwe Plant ID (opcional)">
                    <Input placeholder="ID da planta no Goodwe" />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 24, gap: 8 }}>
                    {currentStep > 0 && <Button onClick={onPrev}>Voltar</Button>}
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                        {currentStep < totalSteps - 1 && (
                            <Button onClick={onNext} disabled={!saved}>
                                Próximo
                            </Button>
                        )}
                        <Button type="primary" onClick={handleSave} loading={loading} style={{ backgroundColor: '#2957A4', borderColor: '#2957A4' }}>
                            Salvar
                        </Button>
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default StepUsinaSolar;
